/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import * as z from "zod";

export const Type = {
    ImagePng: "image/png",
    ImageJpg: "image/jpg",
    ImageJpeg: "image/jpeg",
    ImageWebp: "image/webp",
    VideoMp4: "video/mp4",
    VideoWebm: "video/webm",
    ApplicationOctetStream: "application/octet-stream",
} as const;
export type Type = ClosedEnum<typeof Type>;

export type GetUploadUrlRequest = {
    type: Type;
    fileSize: string;
};

/**
 * Retrieve the output
 */
export type GetUploadUrlResponseBody = {
    uploadUrl: string;
    fileId: string;
    downloadUrl: string;
};

/** @internal */
export const Type$inboundSchema: z.ZodNativeEnum<typeof Type> = z.nativeEnum(Type);

/** @internal */
export const Type$outboundSchema: z.ZodNativeEnum<typeof Type> = Type$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace Type$ {
    /** @deprecated use `Type$inboundSchema` instead. */
    export const inboundSchema = Type$inboundSchema;
    /** @deprecated use `Type$outboundSchema` instead. */
    export const outboundSchema = Type$outboundSchema;
}

/** @internal */
export const GetUploadUrlRequest$inboundSchema: z.ZodType<
    GetUploadUrlRequest,
    z.ZodTypeDef,
    unknown
> = z
    .object({
        type: Type$inboundSchema,
        file_size: z.string(),
    })
    .transform((v) => {
        return remap$(v, {
            file_size: "fileSize",
        });
    });

/** @internal */
export type GetUploadUrlRequest$Outbound = {
    type: string;
    file_size: string;
};

/** @internal */
export const GetUploadUrlRequest$outboundSchema: z.ZodType<
    GetUploadUrlRequest$Outbound,
    z.ZodTypeDef,
    GetUploadUrlRequest
> = z
    .object({
        type: Type$outboundSchema,
        fileSize: z.string(),
    })
    .transform((v) => {
        return remap$(v, {
            fileSize: "file_size",
        });
    });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetUploadUrlRequest$ {
    /** @deprecated use `GetUploadUrlRequest$inboundSchema` instead. */
    export const inboundSchema = GetUploadUrlRequest$inboundSchema;
    /** @deprecated use `GetUploadUrlRequest$outboundSchema` instead. */
    export const outboundSchema = GetUploadUrlRequest$outboundSchema;
    /** @deprecated use `GetUploadUrlRequest$Outbound` instead. */
    export type Outbound = GetUploadUrlRequest$Outbound;
}

/** @internal */
export const GetUploadUrlResponseBody$inboundSchema: z.ZodType<
    GetUploadUrlResponseBody,
    z.ZodTypeDef,
    unknown
> = z
    .object({
        upload_url: z.string(),
        file_id: z.string(),
        download_url: z.string(),
    })
    .transform((v) => {
        return remap$(v, {
            upload_url: "uploadUrl",
            file_id: "fileId",
            download_url: "downloadUrl",
        });
    });

/** @internal */
export type GetUploadUrlResponseBody$Outbound = {
    upload_url: string;
    file_id: string;
    download_url: string;
};

/** @internal */
export const GetUploadUrlResponseBody$outboundSchema: z.ZodType<
    GetUploadUrlResponseBody$Outbound,
    z.ZodTypeDef,
    GetUploadUrlResponseBody
> = z
    .object({
        uploadUrl: z.string(),
        fileId: z.string(),
        downloadUrl: z.string(),
    })
    .transform((v) => {
        return remap$(v, {
            uploadUrl: "upload_url",
            fileId: "file_id",
            downloadUrl: "download_url",
        });
    });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetUploadUrlResponseBody$ {
    /** @deprecated use `GetUploadUrlResponseBody$inboundSchema` instead. */
    export const inboundSchema = GetUploadUrlResponseBody$inboundSchema;
    /** @deprecated use `GetUploadUrlResponseBody$outboundSchema` instead. */
    export const outboundSchema = GetUploadUrlResponseBody$outboundSchema;
    /** @deprecated use `GetUploadUrlResponseBody$Outbound` instead. */
    export type Outbound = GetUploadUrlResponseBody$Outbound;
}
